// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-kenya/calculator-kenya-business-loan/calculator-kenya-business-loan.component.scss
// module id = 595
// module chunks = 0